<template>
  <div class="page_legalSubject">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">公司名称</div>
            <el-input v-model="listQuery.CompanyName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">业务类型</div>
            <el-select v-model="listQuery.BusinessUnit" placeholder="" size="small" clearable>
              <el-option label="外包" value="外包"></el-option>
              <el-option label="派遣" value="派遣"></el-option>
              <el-option label="代理招聘" value="代理招聘"></el-option>
              <el-option label="猎头" value="猎头"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <div class="flname">注册地区</div>
            <el-input v-model="listQuery.RegisteredAddress" size="small" clearable></el-input>
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen==-1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="注册资金:">
            <el-select v-model="listQuery.RegisteredCapital" size="small" placeholder="" clearable>
              <el-option label="200万以下" value="200万以下"></el-option>
              <el-option label="200万以上 (含200万)" value="200万以上 (含200万)"></el-option>
              <el-option label="500万以上 (含500万)" value="500万以上 (含500万)"></el-option>
              <el-option label="1000万以上(含1000万)" value="1000万以上(含1000万)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票类型:" label-width="68px">
            <el-select v-model="listQuery.BillingType" size="small" placeholder="" clearable>
              <el-option label="全额" value="全额"></el-option>
              <el-option label="差额" value="差额"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="checkbox">
              <el-checkbox v-model="listQuery.HasHumanResoLicen" true-label="有" false-label="">人力资源许可证</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="checkbox">
              <el-checkbox v-model="listQuery.HasLaborlicense" true-label="有" false-label="">劳务派遣证</el-checkbox>
            </div>
          </el-form-item>
          <div>
            <el-form-item label="社保户:">
              <el-select v-model="listQuery.IsSsaccount" size="small" placeholder="" clearable>
                <el-option label="有" value="有"></el-option>
                <el-option label="无" value="无"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公积金户:" label-width="68px">
              <el-select v-model="listQuery.IsAfund" size="small" placeholder="" clearable>
                <el-option label="有" value="有"></el-option>
                <el-option label="无" value="无"></el-option>
              </el-select>
            </el-form-item>
          </div>

        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <!-- <el-breadcrumb-item :to="{ path: '/customList' }">客户列表</el-breadcrumb-item> -->
          <el-breadcrumb-item>法务主体信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="listQuery.SubType" type="card" @tab-click="getlegalsubjectlist">
          <el-tab-pane label="内部主体" name="0"></el-tab-pane>
          <el-tab-pane label="外部主体" name="1"></el-tab-pane>
        </el-tabs>
        <el-table :data="tableData" border :max-height="tableHeight-100" class="doc_table" v-loading="loading">
          <el-table-column prop="SerialNumber" label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="CompanyName" label="公司全称" width="266" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <div class="comyName cp" @click="toDdetail(scope.row)">{{ scope.row.CompanyName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="BusinessUnit" label="业务类型" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="type" label="主体属性" width="80" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.type == true ? '独立' : row.type == false ?'分公司' : '' }}</template>
          </el-table-column>
          <el-table-column prop="RegisteredAddress" label="注册地区" width="180" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.RegisteredAddress && scope.row.RegisteredAddress.indexOf('$$')>-1 ? scope.row.RegisteredAddress.replace('$$','') : scope.row.RegisteredAddress.split('/')[0].replace(/,/g,'-') + '；' + scope.row.RegisteredAddress.split('/')[1] }}
            </template>
          </el-table-column>
          <el-table-column prop="RegisteredTime" label="成立时间" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.RegisteredTime ? scope.row.RegisteredTime.split('T')[0] : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="RegisteredCapital" label="注册资金（万）" width="130" align="center">
            <template slot-scope="{row}">
              {{ row.RegisteredCapital == 0 ? '分公司无注册资金' : row.RegisteredCapital }}
            </template>
          </el-table-column>
          <el-table-column prop="LegalPerson" label="法人/负责人" width="100" align="center">
            <!-- <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.LegalPersonId)" v-show="row.LegalPersonId && row.LegalPerson" title="点击查看联系方式">{{row.LegalPerson}}</span>
              </el-popover>
            </template> -->
          </el-table-column>
          <el-table-column prop="IsSsaccount" label="社保户" width="100" align="center">
          </el-table-column>
          <el-table-column prop="IsAfund" label="公积金户" width="100" align="center">
          </el-table-column>
          <el-table-column prop="HasHumanResoLicen" label="人力资源证" width="100" align="center">
          </el-table-column>
          <el-table-column prop="HasHumanResoLicen" label="人力资源证附件" width="120" align="center">
            <template slot-scope="scope">
              <span class="greenName cp" v-if="scope.row.HumanResoLicenUrl" @click="down(scope.row.HumanResoLicenUrl)">下载</span>
            </template>
          </el-table-column>
          <el-table-column prop="HasLaborlicense" label="劳务派遣证" width="100" align="center">
          </el-table-column>
          <el-table-column prop="LaborlicenseUrl" label="劳务派遣证附件" width="120" align="center">
            <template slot-scope="scope">
              <span class="greenName cp" v-if="scope.row.LaborlicenseUrl" @click="down(scope.row.LaborlicenseUrl)">下载</span>
            </template>
          </el-table-column>
          <el-table-column prop="CompanyStuat" label="公司状态" width="100" align="center">
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        tableHeight: 0,
        showDropScreen: -1, //筛选下拉框 
        loading: false,
        listQuery: {
          SubType: '0', //主体类型0:内部.1:外部
          CompanyName: '',
          BusinessUnit: '',
          HasHumanResoLicen: '',
          HasLaborlicense: '',
          BillingType: '',
          LaborlicenseUrl: '',
          RegisteredAddress: '',
          CompanyStuat: '启用',
          pageNum: 1,
          pageSize: '10'
        },
        totalCount: 0,
        scaleList: [],
        tableData: [],
        gridData: [], //联系方式
        gridloading: false,
      };
    },
    created() {
      this.calHeight();
      this.getlegalsubjectlist();
    },
    methods: {
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        this.loading = true;
        // if (this.listQuery.HasHumanResoLicen) {
        //   this.listQuery.HasHumanResoLicen = '有'
        // }
        // if (this.listQuery.HasLaborlicense) {
        //   this.listQuery.HasLaborlicense = '有'
        // }
        this.listQuery.SubType = Number(this.listQuery.SubType);
        xz.getlegalsubjectlist(this.listQuery).then(res => {
          if (res.status == 'ok') {
            // if (this.listQuery.HasHumanResoLicen == '有') {
            //   this.listQuery.HasHumanResoLicen = true
            // }
            // if (this.listQuery.HasLaborlicense == '有') {
            //   this.listQuery.HasLaborlicense = true
            // }
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.$message.error('系统出错')
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getlegalsubjectlist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getlegalsubjectlist();
      },
      // 清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      searchHandle() {
        this.getlegalsubjectlist();
        this.showDropScreen = -1;
      },
      //查看详情
      toDdetail(row) {
        this.$router.push({
          path: '/legalSubjectInfo',
          query: {
            Id: row.Id,
            FinanceID: row.FinanceID
          }
        })
      },
      switchStatus(row) {
        this.loading = true;
        let data = {};
        xz.getlegalsubjectdetails(row.Id).then(res => {
          if (res.status == 'ok') {
            data = res.data;
            data.CompanyStuat = row.CompanyStuat;
            data.Id = row.Id;
            xz.updatelegalsubject(data).then(res => {
              if (res.status == 'ok') {
                this.getlegalsubjectlist();
                this.$message.success(row.CompanyStuat + '成功！');
                this.loading = false;
              } else {
                this.$message.error(res.msg)
                this.loading = false;
              }
            })
          }
        })

      },
      addLeg() {
        const routerUrl = this.$router.resolve({
          path: "/addLegSub",
          query: {},
        });
        window.open(routerUrl.href, "_blank");
      },
      editInfo(row) {
        const routerUrl = this.$router.resolve({
          path: "/addLegSub",
          query: {
            Id: row.Id,
            FinanceID: row.FinanceID
          },
        });
        window.open(routerUrl.href, "_blank");
      },
      getPhone(id) {
        this.gridData = [];
        this.gridloading = true;
        let dtlQuery = {
          mainuserid: '',
          useridr: id
        }
        xz.getauthJbUserDetail(dtlQuery).then(res => {
          if (res.status == 'ok') {
            this.gridData = [{
              phone: res.msg.Strmobile
            }]
          } else {
            this.$message.error('获取联系方式失败')
            this.gridData = []
          }
        })
        this.gridloading = false;
      },
      down(url) {
        var path = this.$store.state.EMP.docPath + url;
        const newWindow = window.open(path, "_blank");
        // const aTag = document.createElement('a')
        // aTag.href = path;
        // aTag.setAttribute('download', row.name);
        // aTag.click();
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .checkbox {
    height: 32px;
    line-height: 32px;
    /* width: 268px; */
    padding: 0 10px 0 30px;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .comyName {
    color: #19bd92;
  }

  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }
</style>
<style>
  .page_legalSubject .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .page_legalSubject .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .page_legalSubject .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .page_legalSubject .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .page_legalSubject .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .page_legalSubject .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .page_legalSubject .screenInputs .screenInput .el-select .el-input__inner,
  .page_legalSubject .re_down_form.el-form--inline .el-form-item__content,
  .page_legalSubject .re_down_form .el-select,
  .page_legalSubject .re_down_form .el-form-item__content,
  .page_legalSubject .screenInput .el-input {
    width: 200px !important;
  }

  /* .doc_table.el-table .cell {
    padding: 0 5px;
  } */

  .page_legalSubject .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_legalSubject .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }


  .page_legalSubject .r_dropDownScreen .el-select .el-input .el-select__caret {
    line-height: 40px;
  }
</style>